<template>
  <el-dialog title='添加备注' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='600px'>
    <el-form :model='form' label-width='80px' label-position='right' :rules='rules'
             ref='ruleForm' class='settlement-form mt20'>
      <el-form-item label='备注：' prop='message'>
        <el-input v-model='form.message' :rows='2' type='textarea' size='mini'
                  placeholder='请输入备注' />
      </el-form-item>
      <div class='flex-center-center mt20 mb20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { reconciliationDetailsAdd } from '@/service/financial';

  export default {
    name: 'reconciliationDetailsForm',
    data() {
      return {
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          message: '',
        },
        rules: {
          message: [{
            required: true,
            message: '请输入备注',
            trigger: 'blur',
          }],
        },
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(ids) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.id = ids.join(',');
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const {
              status,
              message,
            } = await reconciliationDetailsAdd(this.form);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('clearCheckTableData');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }
</style>
